import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  classControls: 'mx-4 rounded-full bg-white/50 p-2 shadow-sm',
  spacing: {
    none: 0,
    xsmall: 0.25,
    small: 0.5,
    medium: 1,
    large: 1.5,
    xlarge: 2
  }
} satisfies RecursivePartial<CMSConfig['collection']>
